module.exports = __webpack_public_path__ + "img/99icon_white.cb4523b0.svg";